<template>
  <div
    class="certificate"
    ref="certBody"
    :style="`background-image: url(${certBgSrc});`"
  >
    <div class="certificate-cert">
      <div class="certificate-cert__upper">
        <div class="certificate-cert__upper-left">
          <div class="certificate__proudly">
            <div class="certificate__proudly__ine-logo">
              <img src="@/assets/images/ine-logo-black.png" alt="INE Logo" />
            </div>
            <div class="certificate__proudly-label">
              <img :src="presentedToSrc" alt="PROUDLY PRESENTED TO" />
            </div>
          </div>
          <h1 class="certificate__username">
            {{ fullName }}
          </h1>
        </div>
        <div class="certificate-cert__upper-right">
          <div class="certificate__badge">
            <img
              :src="badgeSrc"
              :alt="`${certificate.certification_name} badge`"
            />
          </div>
        </div>
      </div>
      <div class="certificate-cert__middle">
        <div v-if="type === els" class="certificate-cert__middle__border"></div>
        <div class="certificate__type-wrapper">
          <h3 class="certificate__title">{{ certName }}</h3>
          <div class="certificate__description">
            eLearnSecurity <br />{{ certDescription }}
          </div>
        </div>
        <div class="certificate__details">
          <div class="certificate__details-field-qr" ref="qrcode"></div>
          <div class="certificate__details-field-wrapper">
            <div class="certificate__details-field">
              <div class="certificate__details-subtitle">Date awarded</div>
              <div class="certificate__details-data">
                {{ awardedAt }}
              </div>
            </div>
            <div class="certificate__details-field">
              <div class="certificate__details-subtitle">Certification ID</div>
              <div class="certificate__details-data">#{{ shortenUUID }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="certificate__bottom">
        <div class="certificate__signature certificate__signature--director">
          <div>
            <img
              class="certificate__signature-img certificate__signature-img--director"
              src="@/assets/images/certification/tw-signature.png"
              alt="Jack Reedy signature"
            />
          </div>
          <div class="certificate__signature-name-wrapper">
            <div class="certificate__signature-name">Tracy Wallace</div>
            <div class="certificate__signature-position">
              Director of Content Development
            </div>
          </div>
        </div>
        <div
          class="certificate__signature certificate__signature--chief-executive"
        >
          <div>
            <img
              class="certificate__signature-img certificate__signature-img--chief-executive"
              src="@/assets/images/certification/dw-signature.png"
              alt="Dara Warn signature"
            />
          </div>
          <div class="certificate__signature-name-wrapper">
            <div class="certificate__signature-name">Dara Warn</div>
            <div class="certificate__signature-position">
              Chief Executive Officer
            </div>
          </div>
        </div>
        <div class="certificate__logo-wrapper">
          <img
            src="@/assets/images/certification/els-logo.png"
            alt="eJPTv Logo"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CONSTANTS from '@/constants'
import QRCodeStyling from 'qr-code-styling'
import { textDate } from '@/helpers'

export default {
  name: 'CertificationTemplate',
  props: {
    certificate: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data: () => {
    return {
      els: CONSTANTS.CERTIFICATES.TYPES.ELS,
      eda: CONSTANTS.CERTIFICATES.TYPES.EDA,
      qrCode: null,
    }
  },
  computed: {
    presentedToSrc() {
      let imgSrc = ''
      switch (this.type) {
        case this.els:
          imgSrc = require('@/assets/images/certification/proudly-subtitle.png')
          break
        case this.eda:
          imgSrc = require('@/assets/images/certification/proudly-subtitle-two.png')
          break
      }
      return imgSrc
    },
    fullName() {
      return `${this.certificate.first_name} ${this.certificate.last_name}`
    },
    certBgSrc() {
      let imgSrc = ''
      switch (this.type) {
        case this.els:
          imgSrc = require('@/assets/images/certification/els-badge-background.png')
          break
        case this.eda:
          imgSrc = require('@/assets/images/certification/eda-badge-background.png')
          break
      }
      return imgSrc
    },
    badgeSrc() {
      let imgSrc = ''
      switch (this.type) {
        case this.els:
          imgSrc = require('@/assets/images/certification/ejpt_badge_white.png')
          break
        case this.eda:
          imgSrc = require('@/assets/images/certification/eeda_badge_white.png')
          break
      }
      return imgSrc
    },
    certName() {
      let certName = ''
      switch (this.type) {
        case this.els:
          certName = 'eJPT'
          break
        case this.eda:
          certName = 'eEDA'
          break
      }
      return certName
    },
    certDescription() {
      let certName = ''
      switch (this.type) {
        case this.els:
          certName = 'Junior Penetration Tester'
          break
        case this.eda:
          certName = 'Enterprise Defense Administrator'
          break
      }
      return certName
    },
    awardedAt() {
      return textDate(this.certificate.finished_at)
    },
    shortenUUID() {
      return this.certificate.attempt_id
        ? this.certificate.attempt_id.split('-')[0]
        : ''
    },
    certificateURL() {
      return `${window.location.origin}/certificate/${this.certificate.attempt_id}`
    },
  },
  methods: {},
  async mounted() {
    let cerType = {}
    switch (this.type) {
      case this.els:
        cerType = {
          imgSrc: require('@/assets/images/certification/els-qr-icon.png'),
          dotsOptions: {
            type: 'rounded',
            color: '#6a1a4c',
            gradient: {
              type: 'linear',
              rotation: 16.9,
              colorStops: [
                {
                  offset: 0,
                  color: '#ad00a6',
                },
                {
                  offset: 1,
                  color: '#e10321',
                },
              ],
            },
          },
          cornersSquareOptions: {
            type: 'square',
            color: '#e10321',
            gradient: null,
          },
          cornersDotOptions: {
            type: 'square',
            color: '#e10321',
          },
        }
        break
      case this.eda:
        cerType = {
          imgSrc: require('@/assets/images/certification/eda-qr-icon.png'),
          dotsOptions: {
            type: 'rounded',
            color: '#6a1a4c',
            gradient: {
              type: 'linear',
              rotation: 0,
              colorStops: [
                {
                  offset: 0,
                  color: '#744299',
                },
                {
                  offset: 1,
                  color: '#41A2D3',
                },
              ],
            },
          },
          cornersSquareOptions: {
            type: 'square',
            color: '#744299',
            gradient: {
              type: 'radial',
              rotation: 16.9,
              colorStops: [
                {
                  offset: 0,
                  color: '#41A2D3',
                },
                {
                  offset: 1,
                  color: '#744299',
                },
              ],
            },
          },
          cornersDotOptions: {
            type: 'square',
            color: '#000000',
            gradient: {
              type: 'radial',
              rotation: 16.9,
              colorStops: [
                {
                  offset: 0,
                  color: '#41A2D3',
                },
                {
                  offset: 1,
                  color: '#744299',
                },
              ],
            },
          },
        }
        break
    }
    const options = {
      width: 148,
      height: 148,
      type: 'svg',
      data: `${this.certificateURL}`,
      margin: 0,
      qrOptions: {
        typeNumber: '0',
        mode: 'Byte',
        errorCorrectionLevel: 'M',
      },
      imageOptions: {
        hideBackgroundDots: true,
        imageSize: 0.8,
        margin: 4,
      },
      dotsOptions: cerType.dotsOptions,
      backgroundOptions: {
        color: '#ffffff',
      },
      image: cerType.imgSrc,
      dotsOptionsHelper: {
        colorType: {
          single: true,
          gradient: false,
        },
        gradient: {
          linear: true,
          radial: false,
          color1: '#6a1a4c',
          color2: '#6a1a4c',
          rotation: '0',
        },
      },
      cornersSquareOptions: cerType.cornersSquareOptions,
      cornersSquareOptionsHelper: {
        colorType: {
          single: true,
          gradient: false,
        },
        gradient: {
          linear: true,
          radial: false,
          color1: '#000000',
          color2: '#000000',
          rotation: '0',
        },
      },
      cornersDotOptions: cerType.cornersDotOptions,
      cornersDotOptionsHelper: {
        colorType: {
          single: true,
          gradient: false,
        },
        gradient: {
          linear: true,
          radial: false,
          color1: '#000000',
          color2: '#000000',
          rotation: '0',
        },
      },
      backgroundOptionsHelper: {
        colorType: {
          single: true,
          gradient: false,
        },
        gradient: {
          linear: true,
          radial: false,
          color1: '#ffffff',
          color2: '#ffffff',
          rotation: '0',
        },
      },
    }
    // Create new QRCode Object
    this.qrCode = new QRCodeStyling(options)
    this.qrCode.append(this.$refs.qrcode)
  },
}
</script>

<style lang="scss" scoped>
.certificate {
  color: var(--white);
  position: relative;

  height: 100%;
  z-index: 1000;
  display: flex;
  flex-direction: column;

  color: var(--aubergine);
  background: var(--white);

  background-repeat: no-repeat;
  background-position-y: top;
  background-position-x: calc(100% + 1px);

  width: 335px;
  background-size: 161px 181px;
  margin-bottom: 10px;

  position: relative;

  @include mobile {
    width: 725px;
    background-size: 380px 420px;
    margin-bottom: 15px;
  }

  @include tablet {
    width: 1073px;
    max-width: calc(100vw - 50px);
    background-size: 521px 590px;
    margin-bottom: 20px;
  }
  &__badge {
    position: absolute;
    width: 79px;
    right: 15px;
    top: 5px;
    @include mobile {
      width: 165px;
      top: 10px;
      right: 30px;
    }
    @include tablet {
      width: 250px;
      top: 20px;
      right: 53px;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }

  &__badge:after {
    content: '';
    width: 15px;
    height: 15px;
    position: absolute;
    top: 50%;
    left: 50%;
    box-shadow: -1px 1px 100px 60px rgb(51 51 51 / 50%);
    border-radius: 50%;

    @include mobile {
      width: 30px;
      height: 30px;
      box-shadow: -1px 1px 150px 120px rgb(51 51 51 / 50%);
    }
  }
  &__type-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    margin: 0 0 8px 0;

    @include mobile {
      gap: 45px;
      margin-bottom: 14px;
    }
    @include tablet {
      gap: 55px;
      margin: 0 0 15px 0;
    }
  }
  &__title {
    margin: 0;
    font-weight: bold;
    font-size: rem(13);
    line-height: rem(15);
    color: var(--auberigne);
    font-family: var(--font-bold);
    width: 54px;
    @include mobile {
      width: fit-content;
      font-size: rem(33);
      line-height: rem(33);
    }

    @include tablet {
      font-size: rem(53);
      line-height: normal;
    }
  }
  &__description {
    font-size: rem(6);
    font-family: var(--font-bold);
    line-height: 7px;
    @include mobile {
      font-size: rem(16);
      line-height: 14px;
    }
    @include tablet {
      font-size: rem(23);
      line-height: rem(23);
    }
  }
  &__username {
    margin: 0 0 16px 0;
    font-weight: bold;
    font-size: rem(16);
    font-family: var(--font-bold);
    font-weight: 900;
    color: var(--aubergine);
    line-height: 12px;
    max-width: 150px;
    height: 38px;
    @include mobile {
      width: 100%;
      height: 76.5px;
      max-width: 335px;
      margin: 0 0 34px 0;
      font-size: rem(36);
      line-height: 44px;
    }

    @include tablet {
      font-size: rem(57);
      line-height: rem(57);
      margin: 15px 0 47px 0;
      width: 100%;
      height: 117px;
      max-width: 562px;
    }

    &-certification {
      background: var(--red-gradient);
      border-radius: 20px;
      font-size: rem(8);
      padding: 3px 7px;
      color: var(--white);

      @include mobile {
        border-radius: 20px;
        font-size: rem(12);
        padding: 5px 15px;
      }
    }
  }
  &__proudly {
    display: flex;
    position: relative;
    margin-bottom: 8px;
    flex-direction: column;
    gap: 2px;
    @include tablet {
      gap: 5px;
    }
    @include desktop {
      gap: 40px;
    }
    &__ine-logo {
      img {
        width: 60px;
        @include tablet {
          width: 170px;
        }
        @include desktop {
          width: 205px;
        }
      }
    }
    &-label {
      img {
        width: 110px;

        @include tablet {
          width: 185px;
        }
        @include desktop {
          width: 320px;
        }
      }
    }
  }
  &-cert {
    padding: 15px 25px;
    display: flex;
    flex-direction: column;
    position: relative;
    @include mobile {
      padding: 35px 60px 45px 60px;
    }

    @include tablet {
      padding: 80px 80px 70px 80px;
    }

    &__upper {
      display: flex;
      flex-direction: row;
      width: 290px;

      @include mobile {
        width: 600px;
      }
      @include tablet {
        width: 870px;
      }
      &-left {
        width: 100%;
      }
    }

    &__middle {
      position: relative;

      &__border {
        margin-top: 1%;
        height: 96%;
        position: absolute;
        background: var(--purple-vertical-gradient);
        width: 3px;
        margin-left: -25px;
        @include mobile {
          margin-left: -60px;
          width: 7px;
        }
        @include tablet {
          margin-left: -80px;
          width: 10px;
        }
      }
    }
  }

  &__details {
    display: flex;
    max-height: 56px;
    @include mobile {
      max-height: 113px;
    }
    @include tablet {
      max-height: 150px;
    }

    &-field {
      display: flex;
      font-size: rem(7);
      line-height: 9px;
      flex-flow: column-reverse;
      @include mobile {
        font-size: rem(12);
        line-height: 15px;
        flex-flow: column-reverse;
      }
      @include tablet {
        font-size: rem(14);
        line-height: 18px;
        flex-flow: column-reverse;
      }

      &-qr {
        transform: translateY(-32%) translatex(-30%) scale(0.37);
        max-width: 55px;
        @include mobile {
          transform: translateY(-12%) translatex(-13%) scale(0.72);
          max-width: 110px;
        }
        @include tablet {
          transform: unset;
          max-width: unset;
        }
      }

      &-wrapper {
        display: flex;
        flex-direction: column;
        margin-left: 8px;
        gap: 5px;
        justify-content: center;

        @include mobile {
          justify-content: initial;
          margin-left: rem(14);
          gap: 10px;
        }
        @include tablet {
          margin-left: rem(34);
          gap: 22px;
        }
      }
    }
    &-subtitle {
      font-size: rem(7);
      color: var(--gray-lavender);
      width: 50px;
      height: 9px;
      @include mobile {
        font-size: rem(8);
        line-height: 15px;
        height: 15px;
        width: unset;
      }
      @include tablet {
        font-size: rem(12);
      }
    }
    &-data {
      font-weight: bold;
      color: var(--aubergine);
    }
  }
  &__bottom {
    position: relative;
    display: flex;
    align-items: flex-end;
    gap: 20px;
    margin-top: 20px;
    @include mobile {
      margin-top: 40px;
      gap: 30px;
    }

    @include desktop {
      gap: 80px;
      margin-top: 75px;
    }
  }
  &__signature {
    display: flex;
    align-self: stretch;
    position: relative;
    &--director {
      width: 110px;
      @include mobile {
        width: 215px;
      }
    }
    &-img {
      &--director {
        width: 76px;
        @include mobile {
          width: 169px;
        }
        @include desktop {
          width: 206px;
        }
      }
      &--chief-executive {
        width: 100px;
        @include mobile {
          width: 236px;
        }
        @include desktop {
          width: 300px;
        }
      }
    }
    &-name-wrapper {
      display: flex;
      position: absolute;
      white-space: nowrap;
      gap: 3px;
      bottom: 10px;
      font-family: var(--font-bold);
      font-size: rem(6);
      line-height: rem(8);
      @include mobile {
        font-size: rem(12);
        line-height: rem(15);
      }
    }
    &-name {
      width: fit-content;
      font-weight: bold;
    }
    &-position {
      color: var(--gray-lavender);
    }
  }
  &__logo-wrapper {
    margin: 0 0 10px auto;
    img {
      width: 54px;

      @include mobile {
        width: 175px;
      }
    }
  }
  img {
    position: relative;
    z-index: 10;
  }
}
</style>
